import React, { useContext, useEffect, useState } from "react";
import { Dropdown, FormControl, InputGroup } from "react-bootstrap";
import newIcon from "../../../assets/newIcn.png";
import "./filter.scss";
import {
  consultationListWithValue,
  appointmentStatusListwithValue,
} from "./constants";
import { filterAPICall } from "./filterAPI";
import searchIcon from "../../../assets/forhomepage/search_icon.svg";
import closeIcon from "../../../assets/forhomepage/close_icon.svg";
import DoctorContext from "../../ClinicComponents/ClinicWrapper/DoctorContext";
import Highlighter from "react-highlight-words";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../../Util/constants";

export const filterType = {
  CONSULTATION: "consultation",
  APPOINTMENTSTATUS: "appointmentStatus",
};

const Filter = ({
  type,
  handleFilter,
  temp_doctor_selected,
  selectedValue,
}) => {
  const [status, setStatus] = useState("");
  const [inputText, setInputText] = useState("");
  const [allConsultationType, setAllConsultationType] = useState([]);
  const [filterConusltationType, setFilterConsultationType] = useState([]);
  // const clinic_id = localStorage.getItem("clinic_id");
  const doctor_context = useContext(DoctorContext);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  // lifecycle methods ==>

  // useEffect to set the list of procedure in consultation type filter
  useEffect(() => {
    getFilterListAPICall();
  }, [temp_doctor_selected, doctor_context?.clinic_id]);

  // useEffect to clear text after clear all
  useEffect(() => {
    if (selectedValue?.value === "all") {
      clearData();
    }
  }, [selectedValue]);

  // <==

  // API Calls ==>
  const getFilterListAPICall = async () => {
    let isStaff = localStorage.getItem("user_type");
    let doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
    let params = {
      doctor_ids:
        (isStaff == "staff" ||
          (isStaff == "doctor" &&
            (doctorRole == USER_ROLE.DOCTOR_ADMIN ||
              doctorRole == USER_ROLE.RESOURCE_ADMIN))) &&
        temp_doctor_selected?.length > 0
          ? Array.isArray(temp_doctor_selected)
            ? temp_doctor_selected
            : [temp_doctor_selected]
          : [userId],
      clinic_id: doctor_context?.clinic_id ? doctor_context?.clinic_id : "",
    };
    let [response, error] = await filterAPICall(
      "/doctor/get-all-procedures",
      params
    );
    if (!error) {
      setAllConsultationType([...consultationListWithValue, ...response]);
      setFilterConsultationType([...consultationListWithValue, ...response]);
    }
  };
  //<==

  // Helper methods ==>
  const handleSearchHelper = (text) => {
    let searchedName = allConsultationType.filter((data) =>
      data.name.toLocaleLowerCase().includes(text.toLocaleLowerCase())
    );

    setFilterConsultationType(searchedName);
  };

  // function to filter the consultation type based on the search string.

  // function to clear consultation type searched string.
  const clearData = () => {
    setInputText("");
    setFilterConsultationType(allConsultationType);
  };
  // <==

  // actions ==>
  const handleSearch = (event) => {
    setInputText(event["search_string"]);
    handleSearchHelper(event["search_string"]);
  };
  // <==

  // Create UI ==>

  const filterButton = () => {
    return (
      <Dropdown>
        <Dropdown.Toggle
          id="dropdownMenu2"
          className="appointment-dropdown-toggle"
        >
          <img className="appointment-calendar-icon" src={newIcon} alt="" />
        </Dropdown.Toggle>

        <Dropdown.Menu className="p-0 filter-dropdown">
          <div className="p-2">{searchBarUI()}</div>
          {renderDropdownList()}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const searchBarUI = () => {
    switch (type) {
      case filterType.CONSULTATION:
        return searchBar();

      case filterType.APPOINTMENTSTATUS:
        return <></>;

      default:
        return "";
    }
  };

  function formatOptionLabel(label, inputValue) {
    return (
      <Highlighter
        highlightClassName="font-weight-bold highlight_background"
        searchWords={[inputValue]}
        autoEscape={true}
        textToHighlight={label}
      />
    );
  }

  const renderDropdownList = () => {
    switch (type) {
      case filterType.CONSULTATION:
        return (
          <>
            {filterConusltationType?.map((item, index) => (
              <Dropdown.Item
                onClick={() => handleFilter(item)}
                className="appointment-dropdown-item d-flex text-label dd-item"
                key={index}
              >
                <i
                  className={`fa fa-check mr-3 check-icon-filter ${
                    selectedValue?.value === item.value ? "activeTab" : ""
                  }`}
                  aria-hidden="true"
                ></i>
                {formatOptionLabel(item.name, inputText)}
                {/* {item.name} */}
              </Dropdown.Item>
            ))}
          </>
        );

      case filterType.APPOINTMENTSTATUS:
        return (
          <>
            {appointmentStatusListwithValue?.map((item, index) => (
              <Dropdown.Item
                onClick={() => handleFilter(item)}
                className="appointment-dropdown-item d-flex text-label"
                key={index}
              >
                <i
                  className={`fa fa-check mr-3 check-icon-filter ${
                    status.value === item.value ? "activeTab" : ""
                  }`}
                  aria-hidden="true"
                ></i>
                {item.name}
              </Dropdown.Item>
            ))}
          </>
        );
      default:
        return "";
    }
  };
  const searchBar = () => {
    return (
      <InputGroup className="search-container">
        <InputGroup.Text className="search-prefix">
          <img src={searchIcon} alt="" />
        </InputGroup.Text>
        <FormControl
          className="search-input"
          // aria-label="Amount (to the nearest dollar)"
          placeholder="Search for Procedure"
          onChange={(e) => handleSearch({ search_string: e.target.value })}
          value={inputText}
        />
        {inputText && (
          <InputGroup.Text className="search-suffix" onClick={clearData}>
            <img src={closeIcon} alt="x" />
          </InputGroup.Text>
        )}
      </InputGroup>
    );
  };

  // <==

  return <div>{filterButton()}</div>;
};

export default Filter;
